import {Component, OnInit, TemplateRef, Injector, ViewChild, ChangeDetectorRef} from '@angular/core';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {CommonService} from 'src/app/core/services/common.service';
import {Message} from '../../../../../../../core/class/message';
import {MatDialog} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {ConfigGeneralManageService} from "../../../../../../../core/services/config-general-manage.service";
import {Subject} from "rxjs";
import {Router} from '@angular/router';
import _ from 'lodash';
import {ContractService} from "../../../../../../../core/services/contract.service";
import {NgForm} from "@angular/forms";
import { ConfigDefaultImageComponent } from '../config-default-image/config-default-image.component';
import { ChooseSmsEventDialogComponent,SmsEventRow } from '../../../document/choose-sms-event-dialog/choose-sms-event-dialog.component'
import { Ls } from 'dayjs';

@Component({
    selector: 'app-config-general-manage',
    templateUrl: './config-general-manage.component.html',
    styleUrls: ['./config-general-manage.component.scss']
})
export class ConfigGeneralManageComponent implements OnInit {
    createSuccess = new Subject();
    documents = new Document();
    isFormChanging = false;
    isVerifySubject = true;
    internalFlowNotEdit = false;
    isClickSendSMSInFlow = false;
    isCheckSendSMSInFlow = false;
    isCheckSendSMSInternalInFlow = false;
    isCheckSendSMSCustomerInFlow = false;
    isCheckSMSInFlow = false;
    isCheckEmailExpire = false;
    isCheckApiSign = false;
    isCheckEmailInFlow = true;
    isOnRemindSignContract = false;
    isCheckEmailSign = false;
    isCheck = false;
    isNotAttestedUser: boolean = false;
    isClick = false;
    isCheckInternal = false;
    isOtpLimited: boolean = false;
    otpLimitedNumber = '';
    isRequiredOTP: boolean = false;
    enableSignOneTime = false;
    entType = localStorage.getItem('entType')
    private checkEscKey: boolean;
    private show: boolean;

    private smsPopupConfigured: { [key: string]: boolean } = {};
    tplModal: NzModalRef;
    isDisableEkyc: boolean = false;
    isDisableEkycAdvanced: boolean = false;
    isInvalidMaxMin: boolean = false;
    @ViewChild('f', {static: false}) ngForm: NgForm;

    quantityEkycInfo = {
        ekycQuantity: 0,
        advanceEkycQuantity: 0,
        isBoughtEkyc: true,
        isBoughtEkycAdvanced: true
    };

    internalObjectsToSendSMS: any[] = [
        {value: '1', viewValue: 'service_type.remind_configuration.objects.signer'},
        {value: '2', viewValue: 'service_type.remind_configuration.objects.approver'},
        {value: '3', viewValue: 'service_type.remind_configuration.objects.initialer'},
        {value: '5', viewValue: 'service_type.remind_configuration.objects.creator'},
    ];
    customerObjectsToSendSMS: any[] = [
    {value: '1', viewValue: 'service_type.remind_configuration.objects.requied_sign'},
    {value: '2', viewValue: 'service_type.remind_configuration.objects.customer_signed'},
    {value: '3', viewValue: 'service_type.remind_configuration.objects.contract_done'},
  ];

    internalObjects: any[] = [
        {value: '1', viewValue: 'search_form.signer'},
        {value: '2', viewValue: 'search_form.approver'},
        {value: '3', viewValue: 'search_form.initialer'},
    ];

    message: Message;
    dialog: MatDialog;
    toastr: ToastrService;
    router: Router;
    modalService: NzModalService;
    commonService: CommonService;
    contractService: ContractService;
    configGeneralManageService: ConfigGeneralManageService;
    fixTowBtn= false;
    
    typeContract = "CONTRACT";
    constructor(private injector: Injector,
          private cdr: ChangeDetectorRef
      ) {
        this.message = injector.get<Message>(Message);
        this.dialog = injector.get<MatDialog>(MatDialog);
        this.toastr = injector.get<ToastrService>(ToastrService);
        this.router = injector.get<Router>(Router);
        this.modalService = injector.get<NzModalService>(NzModalService);
        this.commonService = injector.get<CommonService>(CommonService);
        this.contractService = injector.get<ContractService>(ContractService);
        this.configGeneralManageService = injector.get<ConfigGeneralManageService>(ConfigGeneralManageService);
      this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    }

    ngOnInit() {
        this.documents.notificationServiceTypes = [{
          type: 'IN_FLOW',
          notificationType: 'EMAIL',
          isSendEmailCustomer: true,
          sendEmailInternal: ['1', '2', '3', '5'],
          isActive: true
        }];
        this.onFilterData();
        this.getQuantityEkyc();
    }
    onFilterData() {
        this.configGeneralManageService.filterConfigGeneral().subscribe((res) => {
            if (res.success) {
                if (res.data != null) {
                    if ((res.data.sendSMSInternalInFlow && (res.data.sendSMSInternalInFlow.includes('1') 
                                                                || res.data.sendSMSInternalInFlow.includes('2')
                                                                || res.data.sendSMSInternalInFlow.includes('3')
                                                                || res.data.sendSMSInternalInFlow.includes('5'))) 
                    || (res.data.sendSMSCustomerInFlow && (res.data.sendSMSCustomerInFlow.includes('1')
                                                                 || res.data.sendSMSCustomerInFlow.includes('2')
                                                                 || res.data.sendSMSCustomerInFlow.includes('3') )) ) {
                      this.isCheckSMSInFlow = true;
                    }
                    if (res.data.isOnPromptToSign) {
                        this.isOnRemindSignContract = true;
                    }
                    //sms tien trinh - noi bo
              if (res.data.sendSMSInternalInFlow) {
                const values = _.split(res.data.sendSMSInternalInFlow, ',');
                const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
                 res.data.sendSMSInternalInFlow = hasTarget ? ['1'] : values;
               }
 
             if (!res.data.sendSMSInternalInFlow) {
               res.data.sendSMSInternalInFlow = ['0'];
             }
 
             //sms tien trinh - noi bo
             if (res.data.sendSMSCustomerInFlow) {
               const values = _.split(res.data.sendSMSCustomerInFlow, ',');
               const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
               res.data.sendSMSCustomerInFlow = hasTarget ? ['1'] : values;
             }
             
             if (!res.data.sendSMSCustomerInFlow) {
              res.data.sendSMSCustomerInFlow = ['0'];
            }

            if(res.data.isSendCustomerInFlow && (res.data.sendSMSCustomerInFlow.length == 0 ||res.data.sendSMSCustomerInFlow=="" )) {
              this.documents.sendSMSCustomerInFlow =  ['0'];
            }

                    //sms - nhac xu ly - noi bo
            if (res.data.sendInternalSign) {
              const values = _.split(res.data.sendInternalSign, ',');
              const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
              res.data.sendInternalSign = hasTarget ? ['1'] : values;
            }

            if (!res.data.sendInternalSign) {
              res.data.sendInternalSign = ['0'];
            }
                    if (res.data.sendPromptEmailInternalSign) {
                      res.data.sendPromptEmailInternalSign = _.split(res.data.sendPromptEmailInternalSign, ',');
                    }
                  this.documents = res.data;
                  this.isOtpLimited = this.documents.isOtpLimited ? this.documents.isOtpLimited : false;
                  this.otpLimitedNumber = this.documents.otpLimitedNumber ? this.documents.otpLimitedNumber : '';
                  this.documents.isVerifySubject = !this.documents.isVerifySubject;
                  if(this.documents.isVerifySubject == true){
                    this.documents.checkCertNumber = true;
                    this.documents.checkOtp = true;
                  }
                    if(this.documents.customerImagesConfig == null || !this.documents.customerImagesConfig) {
                      this.documents.customerImagesConfig = ['default_image', 'download_sign_image', 'draw_sign_image'];
                    } else {
                      this.documents.customerImagesConfig = res.data.customerImagesConfig;
                    }
                  if(!res.data.sendSMSCustomerInFlow || res.data.sendSMSCustomerInFlow.length == 0 || res.data.sendSMSCustomerInFlow == "" ) {
                    this.documents.sendSMSCustomerInFlow = ['0'];
                  }
                    if(!this.documents.notificationServiceTypes.length) {
                      this.documents.isOnSMSInFlow = true
                      this.documents.notificationServiceTypes = [
                        {
                        type: 'IN_FLOW',
                        notificationType: 'EMAIL',
                        isSendEmailCustomer: true,
                        sendEmailInternal: ['1', '2', '3', '5'],
                        isActive: true
                      },
                      {
                        type: 'SIGN',
                        notificationType: 'EMAIL',
                        isSendEmailCustomer: this.documents.isSendCustomerSign,
                        sendEmailInternal: this.documents.sendInternalSign,
                        isActive: true
                      },
                      {
                        type: 'EXPIRE_CONTRACT',
                        notificationType: 'EMAIL',
                        isActive: true
                      },
                      {
                        type: 'SIGN',
                        notificationType: 'API',
                        isActive: true
                      }
                    ];
                    }
                    const checkEmail = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'IN_FLOW');
                    if (checkEmail && checkEmail.isActive) {
                      checkEmail.sendEmailInternal = _.split(checkEmail.sendEmailInternal, ',');
                      this.isCheckEmailInFlow = true;
                    } else {
                      this.isCheckEmailInFlow = false;
                    }
                    const checkEmailSign = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'SIGN');
                    if (checkEmailSign && checkEmailSign.isActive) {
                      checkEmailSign.sendEmailInternal = _.split(checkEmailSign.sendEmailInternal, ',');
                      this.isCheckEmailSign = true;
                    }
                    const checkEmailExpire = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'EXPIRE_CONTRACT');
                    if (checkEmailExpire && checkEmailExpire.isActive) {
                      this.isCheckEmailExpire = true;
                    }
                    const checkApiSign = this.documents.notificationServiceTypes.find(api => api.notificationType.toUpperCase() === 'API' && api.type.toUpperCase() === 'SIGN');
                    if (checkApiSign && checkApiSign.isActive) {
                      this.isCheckApiSign = true;
                    }
                    this.isCheckSendSMSCustomerInFlow =this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
                    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
                    if (this.isCheckSendSMSInternalInFlow || this.isCheckSendSMSCustomerInFlow) {
                        this.isCheckSendSMSInFlow = true;
                    }


                    this.isCheckInternal = this.documents.sendInternalSign && (this.documents.sendInternalSign.includes('1') || this.documents.sendInternalSign.includes('2') || this.documents.sendInternalSign.includes('3'));
                    if (this.isCheckInternal || this.documents.isSendCustomerSign) {
                        this.isCheck = true;
                    }
                }
            }
        })
    }

    createOrEditConfigGeneral() {
      if (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0) {
        this.documents.isSendCustomerInFlow = true
      } else {
        this.documents.isSendCustomerInFlow = false ;
      }
        let _clone = this.checkDataBeforeSave();
        if(this.documents && !this.documents.customerImagesConfig.includes('default_image')){
          _clone['defaultImageConfigs'] = null;
        }
        if(_clone['defaultImageConfigs']){
          let isDefault = false;
          _clone['defaultImageConfigs'].forEach(item => {
            isDefault = item.isDefault ? true : isDefault;
          })
          if(!isDefault) _clone['defaultImageConfigs'] = null;
        }
        console.log("_clone", _clone);
        this.configGeneralManageService.createConfigGeneral(_clone).subscribe((res) => {
            if (res.success) {
                this.show = false;
                this.toastr.success(this.message.getMessage(_clone.id ? 'messages.update_success' : 'messages.add_success'));
                this.router.navigate(['/home-enterprise/document-group-manage']);
                this.createSuccess.next();
            } else {
                this.toastr.error(res.data ? res.data.error : res.message);
            }
        }, error => {
            this.toastr.error(error.message ? error.message : error);
        });
    }

    checkDataBeforeSave(): any {
        if (!this.documents.id) {
            if (!this.documents.allowImage) {
                this.documents.allowImage = false;
            }
            if (!this.documents.allowOtp) {
                this.documents.allowOtp = false;
            }
            if (!this.documents.checkCertNumber) {
                this.documents.checkCertNumber = false;
            }
            if (!this.documents.checkName) {
                this.documents.checkName = false;
            }
            if (!this.documents.checkOtp) {
                this.documents.checkOtp = false;
            }
          if (!this.documents.isVerifySubject) {
            this.documents.isVerifySubject = false;
          }
          if (!this.documents.internalFlowNotEdit) {
            this.documents.internalFlowNotEdit = false;
          }
          if (!this.documents.enableSignOneTime || this.entType !== '2') {
            this.documents.enableSignOneTime = false;
          }
            // Do check for configuration send sms when the contract is processed
            if (!this.documents.isOnSMSInFlow) {
                this.documents.isOnSMSInFlow = false;          
            }
            if (!this.documents.sendSMSInternalInFlow) {
                this.documents.sendSMSInternalInFlow = ['0'];
            }
            if (!this.documents.sendSMSCustomerInFlow) {
             this.documents.sendSMSCustomerInFlow = ['0'];
             }
            if (!this.documents.isSendCustomerInFlow) {
                this.documents.isSendCustomerInFlow = false;

            }
            // END Do check for configuration send sms when the contract is processed

            if (!this.documents.isSendSmsSign) {
                this.documents.isSendSmsSign = false;
            }
            if (!this.documents.sendInternalSign) {
                this.documents.sendInternalSign = ['0'];
            }
            if (!this.documents.isSendCustomerSign) {
                this.documents.isSendCustomerSign = false;
            }
            if (!this.documents.isOnPromptToSign) {
                this.documents.isOnPromptToSign = false;
            }
            if (!this.documents.isSendSmsExpireContract) {
                this.documents.isSendSmsExpireContract = false;
            }
            if (!this.documents.isOnNotifyExpireContract) {
                this.documents.isOnNotifyExpireContract = false;
                this.documents.isSendSmsExpireContract = false;
                this.documents.timeNotifyBeforeExpire = null;
                this.documents.cycleNotifyExpireContract = null;
                this.isCheckEmailExpire = false;
            }
        }
        
        if (this.documents.allowOtp) {
          this.documents.isOtpLimited = this.isOtpLimited;
          this.documents.otpLimitedNumber = this.otpLimitedNumber;
        } else {
          this.documents.isOtpLimited = false;
          this.documents.otpLimitedNumber = '';
        }
        const _clone = JSON.parse(JSON.stringify(this.documents));
        _clone.isVerifySubject = !_clone.isVerifySubject
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0) && this.isCheckEmailInFlow) {
          const dataEmail = _clone.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
          if (dataEmail && dataEmail.sendEmailInternal && dataEmail.sendEmailInternal.length > 0) {
            dataEmail.sendEmailInternal = dataEmail.sendEmailInternal.join(',');
          }else {
            dataEmail.sendEmailInternal = ''
          }
        } else {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'IN_FLOW' || data.notificationType.toUpperCase() === 'API'));
        }
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0) && this.isCheckEmailSign && this.documents.isOnPromptToSign) {
          const dataEmailSign = _clone.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
          if (dataEmailSign && dataEmailSign.sendEmailInternal && dataEmailSign.sendEmailInternal.length > 0) {
            dataEmailSign.sendEmailInternal = dataEmailSign.sendEmailInternal.join(',');
          } else {
            dataEmailSign.sendEmailInternal = ''
          }
        } else {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'SIGN') || data.notificationType.toUpperCase() === 'API');
        }
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0) && !this.isCheckEmailExpire || !this.documents.isOnNotifyExpireContract) {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'EXPIRE_CONTRACT') || data.notificationType.toUpperCase() === 'API');
        }
        if (_clone.sendSMSInternalInFlow && _clone.sendSMSInternalInFlow.length > 0) {
            _clone.sendSMSInternalInFlow = _clone.sendSMSInternalInFlow.join(',');
        }
      if (_clone.sendSMSCustomerInFlow && _clone.sendSMSCustomerInFlow.length > 0) {
        _clone.sendSMSCustomerInFlow = _clone.sendSMSCustomerInFlow.join(',');
      }
        if (_clone.sendInternalSign && _clone.sendInternalSign.length > 0) {
            _clone.sendInternalSign = _clone.sendInternalSign.join(',');
        }
        if (_clone.sendPromptEmailInternalSign && _clone.sendPromptEmailInternalSign.length > 0) {
          _clone.sendPromptEmailInternalSign = _clone.sendPromptEmailInternalSign.join(',');
        } else {
          _clone.sendPromptEmailInternalSign = '';
        }
        if (_clone.id) {
            _clone.updatedTime = new Date();
            _clone.createdTime = new Date(_clone.createdTime);
        }
        if (!this.documents.isOnSMSInFlow) {
          this.isCheckSMSInFlow = false;
          _clone.sendSMSCustomerInFlow = ['0'];
          _clone.sendSMSInternalInFlow = ['0'];
          _clone.processSmsConfigs = [];
          _clone.reminderSmsConfigs = [];
          _clone.notificationServiceTypes = (_clone.notificationServiceTypes || []).filter(function (item) {
            return !(item.notificationType === 'EMAIL' && item.type === 'IN_FLOW');
          });
        }

        if(!this.documents.isOnPromptToSign){
          _clone.isSendPromptEmailCustomerSign = false;
          _clone.sendPromptEmailInternalSign = [];
          this.isCheckEmailSign = false;
          this.isCheckApiSign = false;
          _clone.isSendSmsSign = false;
          _clone.isSendCustomerSign = false;
          _clone.sendInternalSign = ['0'];
          _clone.cycleSendSign = null;

        }
        if(!this.documents.isOnNotifyExpireContract){
          _clone.isSendSmsExpireContract = false;
          _clone.timeNotifyBeforeExpire = null;
          _clone.cycleNotifyExpireContract = null;
        }
      console.log(_clone);
        return _clone;
    }

    clickChangeSMSConfiguration(data) {
        this.documents.isOnSMSInFlow = data;
        
        if (this.documents.isOnSMSInFlow === false) {
            this.isFormChanging = true;
            // this.documents.sendSMSInternalInFlow = ['0'];
            // this.documents.isSendCustomerInFlow = false;
            // this.documents.sendSMSCustomerInFlow = ['0'];
        }
    }

    checkSendSMSCustomerInFlow(): void {
        this.isClickSendSMSInFlow = true;
        this.isFormChanging = true;
        if (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.includes('1')) {
        this.documents.sendSMSCustomerInFlow = ['0'];
        this.documents.isSendCustomerInFlow = false;
        this.isCheckSendSMSCustomerInFlow = false;
      } else if(this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.includes('0')) {
        this.documents.sendSMSCustomerInFlow = ['1'];
        this.isCheckSendSMSCustomerInFlow = true;
        this.documents.isSendCustomerInFlow = true;
      }
           
      this.resetSmsPopupConfig('PROCESS', 'customer');
      this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.isCheckSendSMSCustomerInFlow === true;
    }
    checkSendSMSInternalInFlow(): void {
      this.isClickSendSMSInFlow = true;
      this.isFormChanging = true;
      if (this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.includes('1')) {
        this.documents.sendSMSInternalInFlow = ['0'];
        this.isCheckSendSMSInternalInFlow = false;
      } else {
        this.documents.sendSMSInternalInFlow = ['1'];
        this.isCheckSendSMSInternalInFlow = true;
      }
      this.resetSmsPopupConfig('PROCESS', 'internal');
      this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.isCheckSendSMSCustomerInFlow === true;
    }

    checkboxSendSMSCustomerInflow() {
      this.isFormChanging = true;
      this.isCheckSMSInFlow = !this.isCheckSMSInFlow;
      // console.log("isCheckSMSInFlow", this.isCheckSMSInFlow)
      if (!this.isCheckSMSInFlow) {
        this.documents.isSendCustomerInFlow = false;
        this.documents.sendSMSInternalInFlow = ['0'];
        this.documents.sendSMSCustomerInFlow = ['0'];
        this.isCheckSendSMSInternalInFlow = false;
        this.isCheckSendSMSCustomerInFlow = false;
      }
    }

    formChangingCheckSendSMSInternalInFlowEvent() {
      // if (this.documents.sendSMSInternalInFlow.length == 1){
      //   return
      // }
        this.isFormChanging = true;
        this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
        this.isCheckSendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
        if (this.isCheckSendSMSInternalInFlow || this.isCheckSendSMSCustomerInFlow) {
            this.isCheckSendSMSInFlow = true;
        }
    }
  formChangingCheckSendSMSCustomerInFlowEven(){
    this.isFormChanging = true;
    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
    this.isCheckSendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
    if (this.isCheckSendSMSInternalInFlow || this.isCheckSendSMSCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
  }

    clickSend(data) {
        this.documents.isOnPromptToSign = data;
        if (this.documents.isOnPromptToSign === false) {
            this.isFormChanging = true;
            // this.documents.isSendSmsSign = false;
            // this.documents.sendInternalSign = ['0'];
            // this.documents.cycleSendSign = 1;
            // this.documents.isSendCustomerSign = false;
            // this.isCheckEmailSign = false;
            // this.isCheckApiSign = false;
        }
    }

    checkCustomer(): void {
      const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
        this.isClick = true;
        this.documents.isSendPromptEmailCustomerSign = !this.documents.isSendPromptEmailCustomerSign;
        if (emailSign) {
          emailSign.isSendEmailCustomer = this.documents.isSendPromptEmailCustomerSign;
        }
        // Đổi trạng thái checkbox khách hàng (luồng nhắc nhở) -> popup lần sau tự tích hết
        this.isFormChanging = true;
        this.isCheck = this.isCheckInternal === true || this.documents.isSendPromptEmailCustomerSign === true;
    }

    checkInternal(): void {
        this.isClick = true;
        this.isFormChanging = true;
        const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
        if (this.documents.sendPromptEmailInternalSign && this.documents.sendPromptEmailInternalSign.length > 0) {
            this.documents.sendPromptEmailInternalSign = [];
            if (emailSign) {
              emailSign.sendEmailInternal = [];
            }
            this.isCheckInternal = false;
        } else {
            this.documents.sendPromptEmailInternalSign = ['1', '2', '3'];
            if (emailSign) {
              emailSign.sendEmailInternal = ['1', '2', '3'];
            }
            this.isCheckInternal = true;
        }
        this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
    }


    checkCustomerSms(): void {
      const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
        this.isClick = true;
        this.documents.isSendCustomerSign = !this.documents.isSendCustomerSign;
        if (emailSign) {
          emailSign.isSendEmailCustomer = this.documents.isSendCustomerSign;
        }
        // Đổi trạng thái checkbox khách hàng -> popup lần sau tự tích hết
        this.resetSmsPopupConfig('REMINDER', 'customer');
        this.isFormChanging = true;
        this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
    }

    checkInternalSms(): void {
      this.isClick = true;
      this.isFormChanging = true;
      const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
      if (this.documents.sendInternalSign && this.documents.sendInternalSign.includes('1')) {
        this.documents.sendInternalSign = ['0'];
        this.isCheckInternal = false;
      } else {
        this.documents.sendInternalSign = ['1'];
        this.isCheckInternal = true;
      }
      // Đổi trạng thái checkbox nội bộ -> popup lần sau tự tích hết
      this.resetSmsPopupConfig('REMINDER', 'internal');
      this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
    }

    formChangingCheckInternalRemindEvent() {
        this.isFormChanging = true;
        this.isCheckInternal = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0;
        if (this.isCheckInternal || this.documents.isSendCustomerSign) {
            this.isCheck = true;
        }
    }

    private resetSmsPopupConfig(functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER', objectType: 'internal' | 'customer'): void {
      const configKey = this.getConfigArrayKey(functionTypeMode);
      const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';
    
      this.smsPopupConfigured[`${configKey}_${objectType}`] = false;
      this.documents[configKey] = (this.documents[configKey] || [])
        .map(c => ({ ...c, [applyField]: false }));
    }

    checkoff(){
      const list = this.documents.sendInternalSign;
      if (!list || list.includes('1')) {
        this.documents.sendInternalSign = ['0'];
      }
    
      if (this.documents.isSendCustomerSign) {
        this.documents.isSendCustomerSign = false;
      }
    }

    clickSendExpire(data) {
        this.documents.isOnNotifyExpireContract = data;
        if (this.documents.isOnNotifyExpireContract === false) {
            this.isFormChanging = true;
            //   this.documents.isSendSmsExpireContract = false;
            //  this.documents.timeNotifyBeforeExpire = null;
            //  this.documents.cycleNotifyExpireContract = null;
            //  this.isCheckEmailExpire = false;
        }
    }

    onBtnCancelClick() {
        if (this.isFormChanging) {
            this.checkEscKey = true;
            const dialogRe = this.dialog.open(WarningComponent, {
                width: '350px',
                data: this.message.getMessage('messages.confirm_change_data')
            });
            dialogRe.afterClosed().subscribe(rs => {
                if (rs) {
                    this.show = false;
                    this.router.navigate(['/home-enterprise/document-group-manage']);
                }
                dialogRe.close();
                this.checkEscKey = false;
            });
        } else {
            this.router.navigate(['/home-enterprise/document-group-manage']);
        }
    }

    onClickVerifySubject(){
      this.isFormChanging = true;
      this.documents.isVerifySubject = !this.documents.isVerifySubject;
      // console.log("asjkdkasjd",this.documents.isVerifySubject)
      if (this.documents.isVerifySubject) {
        this.documents.checkOtp = true;
        this.documents.checkCertNumber = true;
      }
    }
    onClickSignInternal(){
      this.isFormChanging = true;
      this.documents.internalFlowNotEdit = !this.documents.internalFlowNotEdit;
      // console.log("asjkdkasjd",this.documents.internalFlowNotEdit)
    }

    onClickSignOneTime(){
      this.isFormChanging = true;
      this.documents.enableSignOneTime = !this.documents.enableSignOneTime;
      // console.log("asjkdkasjd",this.documents.enableSignOneTime)
    }

    onAllowCheckSign(type: string): void {
        this.isFormChanging = true;
        switch (type) {
            case "checkCertNumber":
                this.documents.checkCertNumber = !this.documents.checkCertNumber;
                break;
            case "checkName":
                this.documents.checkName = !this.documents.checkName;
                break;
            case "checkOtp":
                this.documents.checkOtp = !this.documents.checkOtp;
                break;
            case "supportEkyc":
                if (this.documents.ekycSupportConfig === 1) {
                    this.documents.ekycSupportConfig = 0;
                } else {
                    this.documents.ekycSupportConfig = 1;
                }
                break;
            case "supportEkycAdvanced":
                if (this.documents.ekycSupportConfig === 2) {
                    this.documents.ekycSupportConfig = 0;
                } else {
                    this.documents.ekycSupportConfig = 2;
                }
                break;
            case "allowOtp":
                this.documents.allowOtp = !this.documents.allowOtp;
                if(this.documents.allowOtp === false) {
                  this.isOtpLimited = false;
                }
                if ((this.documents.allowOtp === false) && (this.documents.allowImage === false)) {
                    this.documents.ekycSupportConfig = 0;
                }
                break;
            case "allowImage":
                this.documents.allowImage = !this.documents.allowImage;
                if ((this.documents.allowOtp === false) && (this.documents.allowImage === false)) {
                    this.documents.ekycSupportConfig = 0;
                }
                break;

            case "imageDefault":
              if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
                this.documents.customerImagesConfig = [];
              }
                if(this.documents.customerImagesConfig.includes('default_image')) {
                  this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'default_image');
                } else {
                  this.documents.customerImagesConfig.push('default_image');
                }
                break;

            case "uploadImage":
              if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
                this.documents.customerImagesConfig = [];
              }
              if(this.documents.customerImagesConfig.includes('download_sign_image')) {
                this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'download_sign_image');
              } else {
                this.documents.customerImagesConfig.push('download_sign_image');
              }
              break;

            case "drawImage":
              if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
                this.documents.customerImagesConfig = [];
              }
              if(this.documents.customerImagesConfig.includes('draw_sign_image')) {
                this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'draw_sign_image');
              } else {
                this.documents.customerImagesConfig.push('draw_sign_image');
              }
              break;
        }
    }
    onAllowSendOTP() {
      this.isFormChanging = true;
      this.isOtpLimited = !this.isOtpLimited;
    }
    getQuantityEkyc() {
        this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(res => {
            if (Object.keys(res.data).length !== 0 && res.data.constructor === Object) {
                //Lấy số lượng ký ekyc và ekyc nâng cao: số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
                if (res.data.ekycQuantity !== undefined) {
                    this.quantityEkycInfo.ekycQuantity = res.data.ekycQuantity;
                } else {
                    this.quantityEkycInfo.isBoughtEkyc = false;
                }

                if (res.data.advanceEkycQuantity !== undefined) {
                    this.quantityEkycInfo.advanceEkycQuantity = res.data.advanceEkycQuantity;
                } else {
                    this.quantityEkycInfo.isBoughtEkycAdvanced = false;
                }
            }
            this.getIsDisabledEkyc(this.quantityEkycInfo);
        })
    }

    getIsDisabledEkyc(quantityEkycInfo: any): void {
        if (!quantityEkycInfo.isBoughtEkyc) {
            this.isDisableEkyc = true;
        }
        if (!quantityEkycInfo.isBoughtEkycAdvanced) {
            this.isDisableEkycAdvanced = true;
        }
    }

    createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
        this.tplModal = this.modalService.create({
            nzTitle: tplTitle,
            nzContent: tplContent,
            nzFooter: tplFooter,
            nzMaskClosable: true,
            nzClosable: true,
            nzOnOk: () => console.log('Click ok')
        });
    }

    destroyTplModal(): void {
        setTimeout(() => {
            this.tplModal.destroy();
        }, 300);
    }

    onChangeCycleSendSignOrNotifyExpire() {
        this.isFormChanging = true;
    }

  checkEmailInFlow(data) {
    return this.isCheckEmailInFlow;
  }
  checkSMSInFlow(data) {
    return this.isCheckSMSInFlow;
  }
  checkSendMailCustomerInFlow(): void {
    this.isFormChanging = true;
    const dataEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
    if (dataEmail) {
      dataEmail.isSendEmailCustomer = !dataEmail.isSendEmailCustomer;
    } else {
      this.documents.notificationServiceTypes.push({
        type: 'IN_FLOW',
        notificationType: 'EMAIL',
        isSendEmailCustomer: true,
        sendEmailInternal: '',
        isActive: true
      });
    }
  }
  getEmailConfig(data): boolean {
    if (!data) return
    const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
    if (email && email.isSendEmailCustomer) return email.isSendEmailCustomer;
  }
  checkboxSendEmailInternalInFlow(data) {
    if (!data) { return false; }
    const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
    if (email && email.sendEmailInternal) {
      return email.sendEmailInternal != '' && email.sendEmailInternal.length > 0;
    } else {
      return false;
    }
  }
  checkSendEmailInternalInFlow(): void {
    this.isFormChanging = true;
    const dataEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
    if (this.documents.notificationServiceTypes && dataEmail && dataEmail.sendEmailInternal != '' && dataEmail.sendEmailInternal.length > 0) {
      dataEmail.sendEmailInternal = [];
    } else {
      if (!dataEmail) {
        this.documents.notificationServiceTypes.push({
          type: 'IN_FLOW',
          notificationType: 'EMAIL',
          isSendEmailCustomer: false,
          sendEmailInternal: ['1', '2', '3', '5'],
          isActive: true
        });
      } else {
        dataEmail.sendEmailInternal = ['1', '2', '3', '5'];
      }
    }
    // this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.documents.isSendCustomerInFlow === true;
  }

  cbxSendEmailInternalInFlow() {
    if(!this.documents.notificationServiceTypes) {
      return
    }
    const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
    if (emailSign) return emailSign.sendEmailInternal;
  }
  formChangingCheckSendEmailInternalInFlowEvent() {
    const sendEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
    this.isFormChanging = true;
    this.isCheckEmailInFlow =
      sendEmail.sendEmailInternal && sendEmail.sendEmailInternal.length > 0;
    if (this.isCheckSendSMSInternalInFlow || this.documents.isSendCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
  }
  getNoteMesage() {
    return this.message.getMessage('service_type.remind_configuration.note_sms_mail');
  }
  checkValidateEmail(data) {
    if (!data) return
    const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
    return email && email.isSendEmailCustomer || (email && email.sendEmailInternal && email.sendEmailInternal.length > 0);
  }
  getIndex(){
    return this.documents.notificationServiceTypes.findIndex((data) => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
  }
  checkSendEmailCustomerInflow() {
    this.isFormChanging = true;
    this.isCheckEmailInFlow = !this.isCheckEmailInFlow;
    this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
    this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'IN_FLOW') || data.notificationType.toUpperCase() === 'API') : [];

    if (this.isCheckEmailInFlow) {
      this.documents.notificationServiceTypes.push({
        type: 'IN_FLOW',
        notificationType: 'EMAIL',
        isSendEmailCustomer: false,
        sendEmailInternal: '',
        isActive: true
      });
    } else {
      this.documents.notificationServiceTypes.push({
        type: 'IN_FLOW',
        notificationType: 'EMAIL',
        isSendEmailCustomer: false,
        sendEmailInternal: '',
        isActive: false
      });
    }
  }

  checkSendApiCustomerSign(){
    this.isCheck = true;
    this.isFormChanging = true;
    this.isCheckApiSign = !this.isCheckApiSign;
    this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
      this.documents.notificationServiceTypes.filter(data => data.notificationType.toUpperCase() !== 'API') : [];
    if (this.isCheckApiSign) {
      this.documents.notificationServiceTypes.push({
        type: 'SIGN',
        notificationType: 'API',
        isActive: true
      });
    } else {
      this.documents.notificationServiceTypes.push({
        type: 'SIGN',
        notificationType: 'API',
        isActive: false
      });
    }
  }

  checkSendEmailCustomerExpire() {
    this.isFormChanging = true;
    this.isCheckEmailExpire = !this.isCheckEmailExpire;
    this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ? this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'EXPIRE_CONTRACT') || data.notificationType.toUpperCase() === 'API') : [];
    if (this.isCheckEmailExpire) {
      this.documents.notificationServiceTypes.push({
        type: 'EXPIRE_CONTRACT',
        notificationType: 'EMAIL',
        isActive: true
      });
    } else {
      this.documents.notificationServiceTypes.push({
        type: 'EXPIRE_CONTRACT',
        notificationType: 'EMAIL',
        isActive: false
      });
    }
  }
  checkSendEmailCustomerSign(){
    this.isFormChanging = true;
    this.isCheckEmailSign = !this.isCheckEmailSign;
    this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
    this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'SIGN') || data.notificationType.toUpperCase() === 'API') : [];
    if (this.isCheckEmailSign) {
      this.documents.notificationServiceTypes.push({
        type: 'SIGN',
        notificationType: 'EMAIL',
        isSendEmailCustomer: this.documents.isSendPromptEmailCustomerSign,
        sendEmailInternal: this.documents.sendPromptEmailInternalSign,
        isActive: true
      });
    } else {
      this.documents.isSendPromptEmailCustomerSign = false;
      this.documents.sendPromptEmailInternalSign = [];
      this.documents.notificationServiceTypes.push({
        type: 'SIGN',
        notificationType: 'EMAIL',
        isSendEmailCustomer: false,
        sendEmailInternal: '',
        isActive: false
      });
    }
    // console.log(this.documents);
  }
  changeValueSign(event: string[]): void {
    const types = this.documents.notificationServiceTypes || [];
    const emailSign = types.find(
      data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN'
    );
    const selected = event || [];
  
    this.documents.sendPromptEmailInternalSign = selected;   // mảng cho mat-select
    if (emailSign) {
      emailSign.sendEmailInternal = selected;                // mảng, khớp với phần load (đã _.split)
    }
  }
  checkDisableInFlow(): boolean {
    if (!this.documents.isOnSMSInFlow) {
      return true
    }
    if(this.isCheckSMSInFlow && this.isCheckEmailInFlow){
      return this.checkValObjEmail() && this.checkValObjSMS()
    }
    if(this.isCheckSMSInFlow) {
      return this.checkValObjSMS()
    }
    if(this.isCheckEmailInFlow) {
      return this.checkValObjEmail()
    }
    return false
  }

  checkValObjSMS() {
    return (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0) || (this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0)
  }

  checkValObjEmail() {
    return this.getEmailConfig(this.documents.notificationServiceTypes) || this.checkboxSendEmailInternalInFlow(this.documents.notificationServiceTypes)
  }

  checkDisableSign() {
    if (!this.documents.isOnPromptToSign) {
      return true
    }
    if (!this.isCheckEmailSign && !this.documents.isSendSmsSign) {
      return this.isCheckApiSign;
    } else {
      // if (this.documents.isSendCustomerSign || (this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0)) {
      //   return true
      // } else {
      //   return false
      // }
      return true;
    }
    
  }

  checkDisableExpire() {
    if (!this.documents.isOnNotifyExpireContract) {
      return true
    }

    return this.isCheckEmailExpire || this.documents.isSendSmsExpireContract
  }
  onChangeotpLimited() {
    console.log(this.otpLimitedNumber);
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  
normalizeValue(event: FocusEvent): void {
  const inputElement = event.target as HTMLInputElement;
  let value = inputElement.value;

  // Xóa các số 0 không cần thiết ở đầu
  if (value) {
    if (value.includes('.')) {
      // Số thập phân: Chuẩn hóa phần nguyên
      const [integerPart, decimalPart] = value.split('.');
      value = parseInt(integerPart || '0', 10) + '.' + (decimalPart || '');
    } else {
      // Số nguyên: Chuyển thành số bình thường
      value = parseInt(value, 10).toString();
    }
  }
  inputElement.value = value;
  this.otpLimitedNumber = value;
}
changeValue(value: any) {
  this.isFormChanging = true;
  if (!(Number(this.otpLimitedNumber) > 0 && Number(this.otpLimitedNumber) < 101)) {
    this.isInvalidMaxMin = true;
  } else {
    this.isInvalidMaxMin = false;
  }
  this.cdr.detectChanges();
}

configDefaultImage(){
  const dialogRe = this.dialog.open(ConfigDefaultImageComponent, {
    width: "80vh",
    data: (this.documents.defaultImageConfigs && this.documents.defaultImageConfigs.length > 0 )? this.documents.defaultImageConfigs : null,
  })
  dialogRe.afterClosed().subscribe(result => {
    if(result){
      this.documents.defaultImageConfigs = result;
      this.changeValue(result)
    }
  })
}

checkIsErrorProcess(): boolean {
  const sendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0
    ? this.documents.sendSMSInternalInFlow
    : ['0'];
  const sendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0
    ? this.documents.sendSMSCustomerInFlow
    : ['0'];

  if(this.isCheckSMSInFlow && !this.documents.isOnSMSInFlow){
    return false;
  }

  if (sendSMSInternalInFlow.includes('0') && sendSMSCustomerInFlow.includes('0') && this.isCheckSMSInFlow) {
    return true;
  } else {
    return false;
  }
}

checkIsErrorRemind(): boolean {
  const sendInternalSign = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0
    ? this.documents.sendInternalSign
    : ['0'];

    if(this.documents.isSendSmsSign && !this.documents.isOnPromptToSign){
    return false;
  }

  if (this.documents.isSendCustomerSign == false && sendInternalSign.includes('0') && this.documents.isSendSmsSign == true) {
    return true;
  } else {
    return false;
  }
}

checkIsErrorRemindEmail(): boolean {
  const raw = this.documents.sendPromptEmailInternalSign;
  const list: string[] = raw ? String(raw).split(',').map(s => s.trim()) : [];
  const isEmpty = list.length === 0 || list.every(s => s === '');

  return this.isCheckEmailSign == true
    && this.documents.isSendPromptEmailCustomerSign == false
    && (isEmpty || list.indexOf('0') !== -1);
}


remindSmsChange(){
  this.isFormChanging = true;
  this.documents.isSendCustomerSign = false;
}

checkSmsExpire(): void {
  this.documents.isSendSmsExpireContract = !this.documents.isSendSmsExpireContract;

  // Đổi trạng thái checkbox SMS (luồng nhắc hết hạn) -> popup lần sau tự tích hết
  this.resetSmsPopupConfig('EXPIRY_REMINDER', 'internal');

  this.isFormChanging = true;
}

chonSuKienGuiSMS(objectType: 'internal' | 'customer', functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER'): void {
  const configKey = this.getConfigArrayKey(functionTypeMode);
  const existingConfigs = this.documents[configKey] || [];

  const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';
  const currentSelected = existingConfigs
    .filter(c => c[applyField])
    .map(c => c.smsTemplateCode);

  // Đã cấu hình khi: có dòng được chọn từ trước, hoặc người dùng đã từng lưu popup này.
  // Chưa cấu hình (hoặc vừa đổi trạng thái checkbox) -> popup tự tích chọn tất cả.
  const flagKey = `${configKey}_${objectType}`;
  const isConfigured = currentSelected.length > 0 || !!this.smsPopupConfigured[flagKey];

  if (this.entType === '2') {
    this.typeContract = "CONTRACT";
  } else if (this.entType === '1') {
    this.typeContract = "CONTRACT";
  }
  let type = '3';
  if (objectType === 'internal') {
    type = '1';
  } else if (objectType === 'customer') {
    type = '2';
  }

  const dialogRef = this.dialog.open(ChooseSmsEventDialogComponent, {
    width: '1100px',
    maxHeight: '90vh',
    data: {
      objectType,
      businessType: this.typeContract,
      applyType: type,
      currentSelected,
      functionType: functionTypeMode,
      isConfigured
    }
  });

  dialogRef.afterClosed().subscribe((result: { rows: SmsEventRow[]; changed: boolean } | null) => {
    if (result && result.rows) {
      this.documents[configKey] = this.mergeSmsConfigs(existingConfigs, result.rows, objectType, configKey);

      // Đã lưu popup: lần sau mở lại phải theo dữ liệu, kể cả khi không chọn dòng nào
      this.smsPopupConfigured[flagKey] = true;

      // rows giờ chứa cả true và false nên phải kiểm tra theo selected
      if (!result.rows.some(r => r.selected)) {
        this.uncheckSendSmsInFlowFlag(objectType, functionTypeMode);
      }
      // Có thay đổi sự kiện SMS trong popup -> bật sáng nút Lưu
      if (result.changed) {
        this.isFormChanging = true;
      }
    }
  });
}

private uncheckSendSmsInFlowFlag(
  objectType: 'internal' | 'customer',
  functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER'
): void {
  const isOn = (arr: string[] | undefined | null): boolean => !!arr && arr.includes('1');

  if (functionTypeMode === 'PROCESS') {
    if (objectType === 'internal' && isOn(this.documents.sendSMSInternalInFlow)) {
      this.checkSendSMSInternalInFlow();
    } else if (objectType === 'customer' && isOn(this.documents.sendSMSCustomerInFlow)) {
      this.checkSendSMSCustomerInFlow();
    }
  } else if (functionTypeMode === 'REMINDER') {
    if (objectType === 'internal' && isOn(this.documents.sendInternalSign)) {
      this.checkInternalSms();
    } else if (objectType === 'customer' && this.documents.isSendCustomerSign) {
      this.checkCustomerSms();
    }
  } else if (functionTypeMode === 'EXPIRY_REMINDER') {
    // Tab này chỉ có 1 checkbox SMS duy nhất, không tách nội bộ/khách hàng,
    // được toggle trực tiếp trong template (không qua hàm riêng)
    if (this.documents.isSendSmsExpireContract) {
      this.documents.isSendSmsExpireContract = false;
    }
  }
}

private mergeSmsConfigs(existingConfigs: any[], selectedResult: SmsEventRow[], objectType: 'internal' | 'customer', configKey: string): any[] {
  // Chỉ những dòng selected = true mới được tính là đã chọn
  const selectedCodes = selectedResult.filter(r => r.selected).map(r => r.code);
  const configs = existingConfigs.map(cfg => ({ ...cfg }));

  if (configKey === 'expirySmsConfigs') {
    // Mảng này chỉ phục vụ nội bộ, không có isApplyCustomer
    return selectedResult.map(item => ({
      smsTemplateId: (item as any).smsTemplateId || (item as any).id,
      smsTemplateCode: item.code,
      isApplyInternal: item.selected
    }));
  }

  const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';

  // Cập nhật lại flag cho các entry đã có sẵn
  configs.forEach(cfg => {
    cfg[applyField] = selectedCodes.includes(cfg.smsTemplateCode);
  });

  // Thêm mới các entry chưa tồn tại trong mảng (kể cả dòng không chọn, flag = false)
  selectedResult.forEach(item => {
    const exist = configs.find(cfg => cfg.smsTemplateCode === item.code);
    if (!exist) {
      configs.push({
        smsTemplateId: (item as any).smsTemplateId || (item as any).id,
        smsTemplateCode: item.code,
        isApplyCustomer: objectType === 'customer' && item.selected,
        isApplyInternal: objectType === 'internal' && item.selected
      });
    }
  });

  // Giữ cả entry có flag false (danh sách có cả true và false)
  return configs;
}

private getConfigArrayKey(functionTypeMode: string): 'processSmsConfigs' | 'reminderSmsConfigs' | 'expirySmsConfigs' {
  switch (functionTypeMode) {
    case 'PROCESS': return 'processSmsConfigs';
    case 'REMINDER': return 'reminderSmsConfigs';
    case 'EXPIRY_REMINDER': return 'expirySmsConfigs';
    default: return 'processSmsConfigs';
  }
}
}

export class Document {
    id: number;
    name: string;
    note: string;
    code: string;
    allowOtp: boolean = false;
    allowImage: boolean = false;
    checkCertNumber: boolean = false;
    checkName: boolean = false;
    checkOtp: boolean = false;
    isSendSmsSign: boolean;
    sendInternalSign: any;
    isSendCustomerSign: boolean;
    cycleSendSign: number;
    isOnPromptToSign = false;
    isOnNotifyExpireContract: boolean;
    isSendSmsExpireContract: boolean;
    timeNotifyBeforeExpire: number;
    cycleNotifyExpireContract: number;
    isOnSMSInFlow = false;
    sendSMSInternalInFlow: any;
    isSendCustomerInFlow: boolean = false;
    ekycSupportConfig: number;
    configGeneral: number = null;
    notificationServiceTypes: any[];
    customerImagesConfig: string[];
    sendSMSCustomerInFlow: any;
    isVerifySubject = false;
    internalFlowNotEdit = false;
    isOtpLimited: boolean;
    otpLimitedNumber: any;
    enableSignOneTime: boolean = false;
    defaultImageConfigs: any[] = null;
    businessType: any;
    processSmsConfigs: any;
    reminderSmsConfigs: any;
    expirySmsConfigs: any;
    isSendPromptEmailCustomerSign: boolean;
    sendPromptEmailInternalSign: any[] = [];
}
